import core, { App, Entities } from '@gin-betting/core';
import matchList from '@gin-betting/match-list';
import { OrderedSet } from 'immutable';
import { TypedAction } from 'redux';
import { TypedEpic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import get from 'ts-get';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';

import { asyncModuleLoaders, AsyncModules } from 'async-modules';
import moduleLocator from 'moduleLocator';
import { Modules } from 'types';

const {
    entities: {
        constants: { GROUP_GET_MATCHES_SUCCESS, MATCH_ENDED, DELETE_MATCH_ID },
    },
    utils: { getRouteFromHistory },
    services: { registerEpic },
} = core;

const {
    selectors: { selectCategoryByLocation },
    constants: { GET_FAVORITE_MATCHES_SUCCESS },
} = matchList;

export const handleListResponse: TypedEpic = (action$, store) => {
    return action$
        .filter(
            (
                action: TypedAction<Entities.SearchMatchesSuccessActionPayload>
            ) => {
                const type = get(action, a => a.type);
                const group = get(action, a => a.meta.group);
                const payload = get(action, a => a.payload);

                if (!payload) return false;

                const { isLoadMore = false, result, isPolling } = payload;

                return (
                    !isLoadMore &&
                    !isPolling &&
                    Array.isArray(result) &&
                    (group === GROUP_GET_MATCHES_SUCCESS ||
                        type === GET_FAVORITE_MATCHES_SUCCESS)
                );
            }
        )
        .switchMap(action => {
            asyncModuleLoaders.stream
                .load()
                .then(streamModule => {
                    const {
                        default: {
                            actions: { addNearestMatchId },
                        },
                    } = (streamModule as unknown) as AsyncModules['stream']; // TODO remove type casting
                    const matchIds = get(action, a => a.payload.result);
                    store.dispatch(addNearestMatchId({ matchIds }));
                })
                .catch(err =>
                    console.warn('Error loading loadStreamModule', err)
                );

            return Observable.empty();
        });
};

const makeHandleMatchEnded = (
    streamModule: Modules['stream']['default']
): TypedEpic => {
    const {
        actions: { addNearestMatchId },
        selectors: { selectIsMatchIdWithOpenedStream },
    } = streamModule;

    return (action$, store) => {
        return action$
            .ofType(MATCH_ENDED, DELETE_MATCH_ID)
            .switchMap(action => {
                const state = store.getState();
                const { matchId } = action.payload;
                const isMatchIdWithOpenedStream = selectIsMatchIdWithOpenedStream(
                    state,
                    { matchId }
                );

                if (!isMatchIdWithOpenedStream) return Observable.empty();

                const route = getRouteFromHistory();

                let matchIds: null | OrderedSet<string> = null;

                switch (route) {
                    case App.Routes.TOURNAMENT:
                    case App.Routes.UPCOMING_LIST:
                    case App.Routes.RESULTS_LIST: {
                        matchIds = selectCategoryByLocation(state, {
                            location: { pathname: route },
                        }).matchIds;

                        break;
                    }

                    default: {
                        break;
                    }
                }

                if (!matchIds) return Observable.empty();

                return Observable.of(
                    addNearestMatchId({ matchIds: matchIds.toArray() })
                );
            });
    };
};

moduleLocator.get('stream').subscribe(streamModule => {
    const handleMatchEnded = makeHandleMatchEnded(streamModule);

    registerEpic(handleMatchEnded);
});
